'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../../hooks';
import { getENV } from '../../../utils/env';
import { useConsentGatedHtml } from '../../hooks';

// This script contains two parts:
// 1. GTM callback function - Called by Contextual Commerce when user is assigned to A/B test group ('baseline' or 'granify').
//    Sends group assignment data to Google Tag Manager for analytics tracking and personalization.
// 2. Contextual Commerce activation - Initializes the BazaarVoice Contextual Commerce library
const contextualCommerceScript = (siteId: string) => `
window.granifyEventGroupAssigned = function(group) {
  dataLayer.push({
    event: 'gfy.groupAssigned',
    granifyGroup: group,
  });
}
function activateGranify(sid) {
	if (!window.Granify) !function(r,t,e){
		var a,n;
		try{
			var i=window.localStorage,o="granify.entry_page."+t,c="granify.entry_referrer."+t;
			if(n=JSON.parse(i.getItem(o)),n&&parseInt(n.expires)>+new Date?n=n.data:(n=null,i.removeItem(o)),!n){
				i.removeItem(c),i.removeItem("granify.entry_page_sent."+t),i.removeItem("granify.entry_referrer_sent."+t);
				var s=window.location,f=window.location.origin;
				a=new Date(+new Date+18e5),f||(s.port?port=":"+s.port:port="",f=s.protocol+"//"+s.hostname+port);
				var y={data:window.location.toString().replace(f,""),expires:+a},p={data:document.referrer,expires:+a};
				i.setItem(o,JSON.stringify(y)),i.setItem(c,JSON.stringify(p))
			}
		} catch(r) {}
		r=r+(-1===r.indexOf("?")?"?":"&")+"id="+t,window.Granify=function(r,t){Granify._functionsAvailable?Granify[r].apply(this,Array.prototype.slice.call(arguments,1)):Granify._stack.push([r].concat(Array.prototype.slice.call(arguments,1)))},Granify._stack=[],Granify._stack.push(["on","granify:init",function(){Granify._functionsAvailable=!0}]),Granify.init=function(r,t,e){for(var a=Granify,n=["on","identify","addTag","trackPageView","trackProduct","trackCart","addToCart","deleteFromCart","trackOrder","setCurrentProduct"],i=0;i<n.length;i++)!function(r,t){r[t]=function(){Granify._stack.push([t].concat(Array.prototype.slice.call(arguments,0)))}}(a,n[i])},Granify.init();var l,d=document.createElement("script");d.src=r,d.async=!0,(l=(l=document.getElementsByTagName("script"))[l.length-1]).parentNode.insertBefore(d,l)
	}("//cdn.granify.com/assets/javascript.js",sid);
}
activateGranify("${siteId}");
`;
export const BazaarVoiceContextualV2 = () => {
  const $ = _c(10);
  const isBazaarVoiceCocoEnabled = useDecisions("bazaarvoice_coco");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getENV("NEXT_PUBLIC_LOCALE");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isCA = t0 === "en-CA";
  let isEnabled;
  let t1;
  if ($[1] !== isBazaarVoiceCocoEnabled) {
    const nextPublicBazaarVoiceSiteIdCa = getENV("NEXT_PUBLIC_BAZAAR_VOICE_SITE_ID_CA");
    const nextPublicBazaarVoiceSiteIdUs = getENV("NEXT_PUBLIC_BAZAAR_VOICE_SITE_ID_US");
    const bazaarVoiceSiteId = isCA ? nextPublicBazaarVoiceSiteIdCa : nextPublicBazaarVoiceSiteIdUs;
    isEnabled = Boolean(isBazaarVoiceCocoEnabled && bazaarVoiceSiteId);
    t1 = bazaarVoiceSiteId ? contextualCommerceScript(bazaarVoiceSiteId) : "";
    $[1] = isBazaarVoiceCocoEnabled;
    $[2] = isEnabled;
    $[3] = t1;
  } else {
    isEnabled = $[2];
    t1 = $[3];
  }
  const scriptContent = t1;
  const html = scriptContent ? "<div id=\"bazaarvoice-contextual-commerce\"></div>" : "";
  let t2;
  if ($[4] !== scriptContent) {
    t2 = () => {
      if (!scriptContent || document.getElementById("bazaarvoice-contextual-commerce-script")) {
        return;
      }
      const script = document.createElement("script");
      script.id = "bazaarvoice-contextual-commerce-script";
      script.textContent = scriptContent;
      document.body.appendChild(script);
    };
    $[4] = scriptContent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== html || $[7] !== isEnabled || $[8] !== t2) {
    t3 = {
      html,
      isEnabled,
      consentGroup: "C0004",
      dedupeId: "bazaarvoice-contextual-commerce",
      onReady: t2
    };
    $[6] = html;
    $[7] = isEnabled;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useConsentGatedHtml(t3);
  return null;
};